import { useEffect } from 'react'
import { Layout, Typography, Empty, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { useAppSelector, useAppDispatch } from '../../utils/redux/store'
import { attemptGetFavs } from '../../utils/redux/favsSlice'
import PlaylistSection from '../../components/PlaylistSection'
import './Library.scss'

const { Content } = Layout
const { Title } = Typography

export default function Library() {
  const { t } = useTranslation('common')
  const dispatch = useAppDispatch()
  const favPlaylists = useAppSelector((state) => state.favs.playlists)

  useEffect(() => {
    dispatch(attemptGetFavs())
  }, [dispatch])

  const favoritePlaylists = favPlaylists || []

  if (!favPlaylists) {
    return (
      <div className="library-loading">
        <Spin size="large" />
      </div>
    )
  }

  return (
    <Content className="library-content">
      <div className="library-container">
        <Title level={2} className="library-title">
          {t('favorites')}
        </Title>

        {favoritePlaylists.length === 0 ? (
          <Empty description="No favorite playlists yet" />
        ) : (
          <PlaylistSection
            title={t('favorites')}
            items={favoritePlaylists}
            type="playlist"
          />
        )}
      </div>
    </Content>
  )
}
